import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'

Vue.use(Vuex, axios, _ )

export default new Vuex.Store({
  state: {    
    user: {
      name: '',
      email: '',
      password: '',
      loggedIn: false
    },
    isLoggedIn: false,
    project: {
        type: 1,
        title: 'новый проект',
        dateCreated: 0,
        dateLastSave: 0,
        tableHeader: [],
        tableData: [],
        totals: []
    },
    columsData: [],
    tableData: [],
    editorData: [],
    recordCount: 0,
    
    dashboard: null,
    workspace: null,
    
    catalog: null, //компонент грида
    editor: null, //компонент грида
    selected: 0,
    mynumber: 0,
    catalogViewer: null, //компонент грида
    catalogViewerData: []
  },

  getters: {
      getUser(state,getters){
        return state.user;
      },
      isLoggedIn(state,getters){
        return state.isLoggedIn;
      },
      get_Project(state,getters){
        return state.project;
      },
      get_ProjectItems_Filtered(state,getters){
        _.filter(state.tableData,[])
        return state.tableData.filter(item => item.qty > 0);  
      },
  },

  mutations: {
    SET_TABLE_DATA(state, data) {
      state.tableData = data;
      state.recordCount = data.length;
    },    
    SET_EDITOR_DATA(state, data){
      state.editorData = data;
      console.log('CLEAR_DATA');
    },
    SET_CATALOG_VIEWER_DATA(state, data) {
      state.catalogViewerData = data;
    },    
  },

  actions: {
    logIn({commit, state}){

    },
    logout({commit, state}){

    },
    newProject ({commit, state}){

    },

    saveProject ({commit, state}){

    },

    loadProject ({commit, state}){

    },

    clearEditor ({commit, state}){
      let emptyData = [];
      commit('SET_EDITOR_DATA', emptyData);
    },

    loadCatalog ({commit, state}, url) {                  
      axios.get(url)
          .then(data => { 
              console.log('URL:' + url);
              console.dir(data.data);
              console.log('loaded: ' + data.data.length + 'rows');
              let rows = data.data;
              commit('SET_TABLE_DATA', rows)
          } )
          .catch(error => { 
            console.log(error);            
          }); 
    }
  }

})
